<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import CompanyGroupForm from '@/components/company-groups/CompanyGroupForm.vue';
    import DialogForm from '@/components/DialogForm.vue';
    import QueryKey from '@/enums/QueryKey';

    const form = useForm({
        name: '',
        companyIds: [],
    });
</script>

<template>
    <DialogForm
        type="create"
        :form="form"
        :route="route('v2.company-groups.store')"
        :query-key="[QueryKey.COMPANY_GROUPS]"
        title="company-groups.company_groups_create"
        success-message="company-groups.created"
        button-text="company-groups.company_groups_create"
    >
        <CompanyGroupForm :form="form" />
    </DialogForm>
</template>
